document.addEventListener('DOMContentLoaded', function () {
  setTimeout(function () {
    document.querySelectorAll('deferred-media').forEach(function (deferredMedia) {
      var template = deferredMedia.querySelector('template');
      if (template && !deferredMedia.querySelector('video, iframe')) {
        deferredMedia.appendChild(template.content.cloneNode(true));
        deferredMedia.classList.add('deferred-media--loaded');
        var video = deferredMedia.querySelector('video');
        if (video) {
          video.muted = true;
          video.play().catch(function(){});
        }
      }
    });
  }, 800);
});